const stateBuilder = require('./stateBuilder');
const actionTypes = require('./actionTypes');

const passportAction = require('./actions/passport/passportAction');

const sideBarAction = require('./actions/views/container/sideBarAction');
const topBarAction = require('./actions/views/container/topBarAction');
const mainBarAction = require('./actions/views/container/mainBarAction');
const mainBarSearchAction = require('./actions/views/container/mainBarSearchAction');
const mainBarComponentAction = require('./actions/views/container/mainBarComponentAction');
const alertAction = require('./actions/views/alertDialogue/alertAction.js');
const modalSpinnerAction = require('./actions/views/modalSpinnerDialogue/modalSpinnerAction.js');
const confirmAction = require('./actions/views/confirmDialogue/confirmAction.js');
const modalFormAction = require('./actions/views/modalForm/modalFormAction.js');
const imageUploadDialogueAction = require('./actions/views/imageUploadDialogue/imageUploadDialogueAction.1.0.0');
const attachmentFormAction = require('./actions/views/attachmentForm/attachmentFormAction.js');
const displayAccountSwitchAction = require('./actions/views/container/displayAccountSwitchAction');

const catalogDataAction = require('./actions/catalogData/catalogData/catalogDataAction');
const orgDataAction = require('./actions/orgData/orgData/orgDataAction');
const catalogLookupAction = require('./actions/catalogData/lookup/lookupAction');
const orgLookupAction = require('./actions/orgData/lookup/lookupAction');
const orgStatesAction = require('./actions/orgStates/orgStatesAction');

export function reducer(previousState, action)
{
    if (!previousState) previousState = stateBuilder.createState();

    if (action.type === actionTypes.environmentInitialized)
    {
        return Object.assign({}, previousState, { environmentInitialized: action.payload });
    }
    
    if (action.type === actionTypes.organizationInitialized)
    {
        return Object.assign({}, previousState, { organizationInitialized: action.payload });
    }

    if (action.type === actionTypes.passport)
    {
        return passportAction.changeState(previousState, action.payload);
    }

    
    if (action.type === actionTypes.sideBarOption)
    {
        return sideBarAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.topBarOption)
    {
        return topBarAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.mainBarOption)
    {
        return mainBarAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.mainBarSearch)
    {
        return mainBarSearchAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.mainBarComponent)
    {
        return mainBarComponentAction.changeState(previousState, action.payload);
    }
    
    if (action.type === actionTypes.alertDialogueUI)
    {
        return alertAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.confirmDialogueUI)
    {
        return confirmAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.modalSpinnerUI)
    {
        return modalSpinnerAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.imageUploadDialogueUI)
    {
        return imageUploadDialogueAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.modalFormUI)
    {
        return modalFormAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.attachmentFormUI)
    {
        return attachmentFormAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.displayAccountSwitch)
    {
        return displayAccountSwitchAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.catalogData)
    {
        return catalogDataAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.catalogLookupData)
    {
        return catalogLookupAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.orgData)
    {
        return orgDataAction.changeState(previousState, action.payload);
    }

    if (action.type === actionTypes.orgStates) 
    {
        return orgStatesAction.changeOrgStatesState(previousState, action.payload);
    }

    if (action.type === actionTypes.orgLookupData)
    {
        // orgLookupData is loaded by orgState
        return orgLookupAction.changeState(action.orgState, previousState, action.payload);
    }

    if (action.type === actionTypes.currentOrgNode) 
    {
        return orgStatesAction.changeCurrentOrgNodeState(previousState, action.payload);
    }

    return previousState;
}

export default reducer;